/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Err_CodeInputs */

const en_signin_err_code = /** @type {(inputs: Signin_Err_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That code is wrong or has expired.`)
};

const id_signin_err_code = /** @type {(inputs: Signin_Err_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kode salah atau sudah kedaluwarsa.`)
};

/**
* | output |
* | --- |
* | "That code is wrong or has expired." |
*
* @param {Signin_Err_CodeInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const signin_err_code = /** @type {((inputs?: Signin_Err_CodeInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Err_CodeInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_signin_err_code(inputs)
	return en_signin_err_code(inputs)
});